export default __webpack_public_path__ + "static/media/Flowers06.bb78d75f.jpg";